import { Base } from '../base';

export class VehicleCheck extends Base {
    VehicleCheckID?: string;
    ParkingID?: number;
    FineID?: string;
    AuthorName?: string;
    Plate?: string;
    Date?: Date;
    Latitude?: number;
    Longitude?: number;
    VehicleCheckStatID?: number;
    FineStatID: number;
    VehicleCheckStat?: string;
    IsValid?: boolean;
    Note: string;
    PvNote: string;
    Pictures?: Array<string>
    Parking?: string;
    ParkingName?: string;
}
